import { render, staticRenderFns } from "./public1.vue?vue&type=template&id=238648f2&scoped=true&"
import script from "./public1.vue?vue&type=script&lang=js&"
export * from "./public1.vue?vue&type=script&lang=js&"
import style0 from "./public1.vue?vue&type=style&index=0&id=238648f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238648f2",
  null
  
)

export default component.exports